<template>
  <div class="root">
    <div class="card" v-for="item in lseeonList" :key="item.id" @click="toClass(item.id)">
      <div class="left" style="color: #000;">
        <Icon style="font-size: 28px;" color="#f48b16e8" type="ios-alarm" />{{ item.start_time }}<br>{{ item.stop_time }}
      </div>
      <div class="right">
        <div class="list" style="font-size: 14px;">
          <div class="weight" style=" font-size: 14px; font-weight: 800; color: #ffc115f0;">
            <Icon type="ios-easel" color="#f48b16e8" size="20" />&nbsp课程名称:<p style="display: inline-block; color: #000;">
              &nbsp&nbsp{{ item.grade_name }}</p>
          </div>
          <div style="color: #ffc115f0; font-weight: 800; ">
            <Icon type="ios-school" color="#f48b16e8" size="21" />
            主教老师:<p style="display: inline-block; color: #000;">&nbsp {{ item.teacher ? item.teacher : "" }}</p>
          </div>
          <div style="color: #ffc115f0; font-weight: 800; " v-if="item.teacher_one">
            <Icon type="md-school" color="#f48b16e8" size="21" />&nbsp助教老师:<p style="display: inline-block; color: #000;">
              &nbsp {{ item.teacher_one ?
                item.teacher_one : "" }} </p>
          </div>
          <div style="font-weight: 800; color: #ffc115f0;">
            <Icon type="ios-list-box" color="#f48b16e8" size="20" />&nbsp班级备注:<p
              style="display: inline-block; color: #000;"> &nbsp {{
                item.lesson }}</p>
          </div>
        </div>
        <div class="arrived">
          <div>
            <div style="color: #000">&nbsp{{ item.student.length }}</div>
            <div style="color: #ffc115f0">应到</div>
          </div>
          <div>
            <div style="color: rgb(5 159 5);">&nbsp{{ item.arrived }}</div>
            <div style="color: #ffc115f0">已到</div>
          </div>
          <div>
            <div style="color: red">
              &nbsp{{ item.student.length - item.arrived }}
            </div>
            <div style="color: #ffc115f0">未到</div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!lseeonList.length" class="state">无数据</div>

  </div>
</template>
<style scoped>
.card {
  background: #fff;
  margin: 13px 10px 7px 10px;
  /* height: 180px; */
  display: flex;
  border-radius: 20px;
  box-shadow: 0.1rem 0.1rem 0.1rem rgb(214, 212, 212);
}

.card .left {
  border-right: 1px solid #eee;
  background-image: linear-gradient(#e3efef, #e3efef);
  flex: 2;
  font-weight: 700;
  color: #ffc115f0;
  font-size: 13px;
  border-radius: 20px 0PX 0PX 20PX;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.card .right {
  flex: 8;
  background-image: linear-gradient(#e3efef, #e3efef);
  border-radius: 0px 20PX 20PX 0PX;
  color: #ffff;
  padding-top: 4px;
}

.right .list div {
  margin-top: 7px;
  margin-left: 10px;
}

.right .arrived {
  display: flex;
  flex-direction: row;
  border-top: 1px solid #ffc115f0;
  margin: 8px 40px 3px 10px;
  justify-content: space-between;

}

.right .arrived>div {
  margin-top: 5px;
}

.weight {
  font-weight: 700;
  font-size: 16px;
}

.state {
  width: 100%;
  padding: 0.4rem 0;
  text-align: center;
  font-size: 0.3rem;
}
</style>

<script>
import { gradeLseeon, getUser } from "@api/user";

export default {
  name: "ClassSgin",
  data: function () {
    return {
      userInfo: {},
      lseeonList: []
    };
  },
  methods: {
    gradeLseeon() {
      var _this = this;
      gradeLseeon(this.userInfo.uid).then(res => {
        var info = Object.values(res.data.info1);
        info.forEach(item => {
          item.student.forEach(stu => {
            if (stu.status == 1) {
              item.arrived++;
            }
          });
        });
        _this.lseeonList = info;
      });
    },
    User: function () {
      let that = this;
      getUser().then(res => {
        that.userInfo = res.data;
        this.gradeLseeon(res.data.uid);
      });
    },
    toClass(e) {
      // console.log(e);
      this.$router.push({ path: '/class/student/' + e })
    }
  },
  mounted: function () {
    this.User();
  },
  watch: {

    '$route'() {

      this.gradeLseeon(); //我的初始化方法; //我的初始化方法

    }

  }
};
</script>
